import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import AppLayout from '../../layouts/AppLayout';
import UserListContainer from './UserListContainer';

const UsersAndRolesContainer: React.FC = () => {

  return (
    <AppLayout>
      <Box sx={{ p: 3 }}>
        {/* Page Header */}
        <Typography variant="h4" gutterBottom sx={{ ml: 3 }}>
          User Management
        </Typography>
        <Box sx={{ p: 3, pt: 2 }}>
          <UserListContainer embedded />
        </Box>
      </Box>
    </AppLayout>
  );
};

export default UsersAndRolesContainer;

